import React, {useRef} from 'react';
import * as S from './ViewRoomDetails.styles';
import smoothScrollIntoView, {SmoothBehaviorOptions} from 'smooth-scroll-into-view-if-needed';
import AmenitiesIconSelector from '../../../../../shared/components/AmenitiesIconSelector';
import {defaultTheme} from 'build-theme/src/build-theme';

const noop = () => {};

const scrollOptions: SmoothBehaviorOptions = {
  behavior: 'smooth',
  inline: 'start',
  block: 'nearest',
};

const ViewRoomDetails = ({
  roomDescription,
  roomFacilities = [],
  roomTypeName,
  roomImages = [],
  closeModal = noop,
  onRightArrowClick = noop,
  onLeftArrowClick = noop,
  showLeftArrow,
  showRightArrow,
  leftCursor,
  rightCursor,
}) => {
  const imageRefs = useRef([]);
  const carouselRootRef = useRef(null);

  return (
    <>
      {/* <S.WrapperDivContainer> */}
      <S.RoomDetailsHeaderWrap>
        {!!roomTypeName && <S.RoomDetailsHeader>{roomTypeName}</S.RoomDetailsHeader>}
        <S.CloseIconWrap onClick={closeModal}></S.CloseIconWrap>
      </S.RoomDetailsHeaderWrap>
      <S.RoomAmenitiesBodyWrap>
        <S.MainGalleryOuterWrapDiv ref={carouselRootRef}>
          <S.CarouselImagesWrapper>
            {roomImages.map((roomImageSrc, i) => (
              <S.HotelMainGalleryImage
                src={roomImageSrc}
                alt={`Room Image ${i}`}
                key={roomImageSrc}
                ref={node => {
                  imageRefs.current.push(node);
                }}
              />
            ))}
          </S.CarouselImagesWrapper>
          <S.ImageTextWrapper>{roomTypeName}</S.ImageTextWrapper>

          {!!showLeftArrow && (
            <S.LeftArrowOuterWrapper
              onClick={() => {
                smoothScrollIntoView(imageRefs.current[leftCursor - 1], scrollOptions);
                onLeftArrowClick();
              }}
            >
              <S.LeftArrow></S.LeftArrow>
            </S.LeftArrowOuterWrapper>
          )}

          {!!showRightArrow && (
            <S.RightArrowOuterWrapper
              onClick={() => {
                smoothScrollIntoView(imageRefs.current[rightCursor], scrollOptions);
                onRightArrowClick();
              }}
            >
              <S.RightArrow></S.RightArrow>
            </S.RightArrowOuterWrapper>
          )}
        </S.MainGalleryOuterWrapDiv>
        {roomDescription && <S.RoomDescription>{roomDescription}</S.RoomDescription>}

        <S.RoomAmenitiesHeader>Room Amenities</S.RoomAmenitiesHeader>
        <S.RoomAmenitiesListWrapper>
          {roomFacilities.map((facilityName: string) => {
            return (
              <S.AmenityListItem key={facilityName}>
                <S.AmenityIconContainer>
                  <AmenitiesIconSelector
                    name={facilityName.trim().toLowerCase()}
                    styleProps={{fill: defaultTheme.colors.grey.base}}
                  />
                </S.AmenityIconContainer>
                <S.RoomAmenitiesList>{facilityName}</S.RoomAmenitiesList>
              </S.AmenityListItem>
            );
          })}
        </S.RoomAmenitiesListWrapper>
      </S.RoomAmenitiesBodyWrap>
      {/* </S.WrapperDivContainer> */}
    </>
  );
};

export default ViewRoomDetails;
